import { Paragraph1, EmptyState } from 'inpock-ui-react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { MarketReview } from '@/components';
import { MarketReview as MarketReviewType } from '@/apis';

interface MarketReviewsProps {
  reviews?: MarketReviewType[];
  loading?: boolean;
  version?: string;
}

export function MarketReviews({ reviews, loading, version }: MarketReviewsProps) {
  if (loading) return <></>;

  return (
    <>
      <div className="section-title">
        <Paragraph1>실시간 리뷰</Paragraph1>
      </div>
      {reviews && reviews.length ? (
        <Swiper spaceBetween={10} slidesPerView={2.5}>
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <MarketReview review={review} version={version} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <EmptyState height={140} className="mt-20" emojii="✍️" subText="등록된 리뷰가 없습니다" />
      )}
    </>
  );
}
